import Background from '../../shared/Background';

export default Background;
